var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.75H1.46094C0.796875 0.75 0.25 1.33594 0.25 2.03906V17C0.25 17.7031 0.796875 18.25 1.46094 18.25H16.5C17.1641 18.25 17.75 17.7031 17.75 17V2.03906C17.75 1.33594 17.1641 0.75 16.5 0.75ZM5.52344 15.75H2.94531V7.42969H5.52344V15.75ZM4.23438 6.25781C3.375 6.25781 2.71094 5.59375 2.71094 4.77344C2.71094 3.95312 3.375 3.25 4.23438 3.25C5.05469 3.25 5.71875 3.95312 5.71875 4.77344C5.71875 5.59375 5.05469 6.25781 4.23438 6.25781ZM15.25 15.75H12.6328V11.6875C12.6328 10.75 12.6328 9.5 11.3047 9.5C9.9375 9.5 9.74219 10.5547 9.74219 11.6484V15.75H7.16406V7.42969H9.625V8.5625H9.66406C10.0156 7.89844 10.875 7.19531 12.125 7.19531C14.7422 7.19531 15.25 8.95312 15.25 11.1797V15.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.bf96331196e24d5e7d43b4ead56b4c67.svg";
export { ForwardRef as ReactComponent };